import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import PropTypes from "prop-types";
import React, { Component } from "react";
import { Timeline } from "react-twitter-widgets";
import { getRehydratableName } from "../../../../../utilities";
/*
 * This is broken out from TwitterCard, so that we don't have an extra
 * `<div>` wrapping the whole card - which would interfere with Grid, and
 * result in a card that has a different height from the other cards.
 *
 * It also means that rehydration is scoped to only the part of the TwitterCard
 * that actually needs rehydrating.
 */

var TwitterCardTimeline = /*#__PURE__*/function (_Component) {
  _inherits(TwitterCardTimeline, _Component);

  var _super = _createSuper(TwitterCardTimeline);

  function TwitterCardTimeline(props) {
    var _this;

    _classCallCheck(this, TwitterCardTimeline);

    _this = _super.call(this, props);
    _this.state = {
      isMounted: false
    };
    return _this;
  }

  _createClass(TwitterCardTimeline, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      /**
       * this is a monkey patch for
       * node_modules/react-twitter-widgets/src/index.js
       *
       * this lib will inline load a script; this is unnecessary as it
       * causes dcl/ui to load twitter libs regardless if the component is used
       *
       * moving this function to componentDidMount ensures we will load
       * twitter libs only when the twitter card is present
       */
      require("scriptjs")("https://platform.twitter.com/widgets.js", "twitter-widgets", function () {
        _this2.setState({
          isMounted: true
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          timelineDataSource = _this$props.timelineDataSource,
          timelineOptions = _this$props.timelineOptions;
      return /*#__PURE__*/React.createElement("div", {
        "data-rehydratable": getRehydratableName(TwitterCardTimeline.displayName),
        "data-timeline-data-source": JSON.stringify(timelineDataSource),
        "data-timeline-options": JSON.stringify(timelineOptions)
      }, this.state.isMounted ? /*#__PURE__*/React.createElement(Timeline, {
        dataSource: timelineDataSource,
        options: timelineOptions
      }) : null);
    }
  }]);

  return TwitterCardTimeline;
}(Component);

_defineProperty(TwitterCardTimeline, "displayName", "TwitterCardTimeline");

_defineProperty(TwitterCardTimeline, "propTypes", {
  /**
   * Data source for the timeline. Conforms to the [Twitter specification for createTimeline](https://dev.twitter.com/web/javascript/creating-widgets#timelines)
   */
  timelineDataSource: PropTypes.object.isRequired,

  /**
   * Display options for the timeline. Conforms to the [Twitter specification for createTimeline](https://dev.twitter.com/web/javascript/creating-widgets#timelines)
   */
  timelineOptions: PropTypes.object
});

export default TwitterCardTimeline;